/**
 * Il pallino verde di «al lavoro adesso» fuori dalla carta (filtri, elenco, riepilogo, scheda): lo stesso verde e la
 * stessa onda dei segni, così si riconosce senza legenda. Senza movimento (preferenza di sistema) resta fermo.
 */
import React from 'react';
import { Box } from '@mui/material';
import { COLORI_MAPPA } from './aspetto';

export const PallinoAdesso: React.FC<{ dimensione?: number; spento?: boolean }> = ({ dimensione = 8, spento = false }) => (
  <Box
    component="span"
    aria-hidden
    sx={{
      position: 'relative',
      display: 'inline-block',
      flexShrink: 0,
      width: dimensione,
      height: dimensione,
      borderRadius: '50%',
      bgcolor: spento ? 'transparent' : COLORI_MAPPA.adesso,
      border: spento ? `1.5px solid ${COLORI_MAPPA.spento}` : 'none',
      '&::after': spento ? undefined : {
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: '50%',
        bgcolor: COLORI_MAPPA.adesso,
        animation: 'pallino-adesso 2.4s cubic-bezier(.2,.6,.3,1) infinite',
      },
      '@keyframes pallino-adesso': { '0%': { transform: 'scale(1)', opacity: 0.6 }, '80%, 100%': { transform: 'scale(2.6)', opacity: 0 } },
      '@media (prefers-reduced-motion: reduce)': { '&::after': { animation: 'none', opacity: 0 } },
    }}
  />
);
